import { IUntypedCommand, Topics } from '@zaplify/common';

/** @deprecated we think... */
export class QualifyProspectsCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly prospectIds: string[]) {
        super();
    }
}
